import React from 'react';
import SEO from '../components/SEO';
import AboutHero from '../components/about/AboutHero';
import AboutStory from '../components/about/AboutStory';
import AboutVisionMissionValues from '../components/about/AboutVisionMissionValues';
import AboutCTA from '../components/about/AboutCTA';
import AboutClients from '../components/about/AboutClients';

const About: React.FC = () => {
  return (
    <div className="min-h-screen">
      <SEO
        title="About Us"
        description="Learn about Bizani Media: our story, vision, mission, and values. We document real life and bring brands and causes to life through film, design, and strategy."
        path="/about"
        keywords="about Bizani Media, vision, mission, values, media company Zimbabwe, creative partner, documentary filmmakers"
      />
      <AboutHero />
      <AboutStory />
      <AboutVisionMissionValues />
      <AboutClients />
      <AboutCTA />
    </div>
  );
};

export default About;
